import "./intro.css"

function FooterComp() {
  return (
    <div className="footer">
        <p>
            All Rights Reserved © 2024.
            This webpage designed by Ekrem Taha Güldeste.
        </p>
    </div>
  );
}

export default FooterComp